import { Route, Routes } from 'react-router-dom';

import { FormWrapper, HeaderAndFormWrapper, Main, PageWrapper } from './index.styles';

import Footer from '../../footer';
import Header from '../../header';
import Heading from '../../heading';
import LoginEmail from './email';
import LoginMain from './main';
import LoginTwoStepEmail from './two_step_email';

export default function LoginPage() {
  return (
    <PageWrapper>
      <HeaderAndFormWrapper>
        <Header />
        <FormWrapper>
          <Main>
            <Heading align="center">Login</Heading>
            <Routes>
              <Route element={<LoginMain />} path="" />
              <Route element={<LoginEmail />} path="email" />
              <Route element={<LoginTwoStepEmail />} path="two_step_email/*" />
            </Routes>
          </Main>
        </FormWrapper>
      </HeaderAndFormWrapper>
      <Footer />
    </PageWrapper>
  );
}
